<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Register Member</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">User information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="National ID"
                                                        placeholder="Eg 3427876"
                                                        input-classes="form-control-alternative"
                                                        v-model="id_no"
                                            />
                                            <p class="message" v-if="!$v.id_no.required"> * National ID detail is required</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Email address"
                                                        placeholder="jesse@example.com"
                                                        input-classes="form-control-alternative"
                                                        v-model="user_email"
                                            />
                                            <p class="message" v-if="!$v.user_email.email"> * Field must be an email</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="First name"
                                                        placeholder="First name"
                                                        input-classes="form-control-alternative"
                                                        v-model="first_name"
                                            />
                                            <p class="message" v-if="!$v.first_name.required"> * First Name detail is required</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Last name"
                                                        placeholder="Last name"
                                                        input-classes="form-control-alternative"
                                                        v-model="last_name"
                                            />
                                            <p class="message" v-if="!$v.last_name.required"> * Last Name detail is required</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Member Shares"
                                                        placeholder="678,900"
                                                        input-classes="form-control-alternative"
                                                        v-model="member_shares"
                                            />
                                            <p class="message" v-if="!$v.member_shares.required"> * Member Shares detail is required</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Gender"
                                                        placeholder="Male/Female"
                                                        input-classes="form-control-alternative"
                                                        v-model="gender"
                                            />
                                            <p class="message" v-if="!$v.gender.required"> * Gender detail is required</p>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Contact information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Telephone"
                                                        placeholder="07457655"
                                                        input-classes="form-control-alternative"
                                                        v-model="telephone"
                                            />
                                            <p class="message" v-if="!$v.telephone.required"> * Telephone detail is required</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Address"
                                                        placeholder="Home Address"
                                                        input-classes="form-control-alternative"
                                                        v-model="address"
                                            />
                                            <p class="message" v-if="!$v.address.required"> * Address detail is required</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Married"
                                                        placeholder="Yes/No"
                                                        input-classes="form-control-alternative"
                                                        v-model="marital_status"
                                            />
                                            <p class="message" v-if="!$v.marital_status.required"> * Marital Status detail is required</p>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Dependents"
                                                        placeholder="1/3/2"
                                                        input-classes="form-control-alternative"
                                                        v-model="dependents"
                                            />
                                            <p class="message" v-if="!$v.dependents.required"> * Dependents detail is required</p>
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Property Area"
                                                        placeholder="Urban/Rural"
                                                        input-classes="form-control-alternative"
                                                        v-model="property_area"
                                            />
                                            <p class="message" v-if="!$v.property_area.required"> * Property Area detail is required</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Education"
                                                        placeholder="Not Graduated/Graduated"
                                                        input-classes="form-control-alternative"
                                                        v-model="education"
                                            />
                                            <p class="message" v-if="!$v.education.required"> * Education detail is required</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Self Employed"
                                                        placeholder="No/Yes"
                                                        input-classes="form-control-alternative"
                                                        v-model="self_employed"
                                            />
                                            <p class="message" v-if="!$v.self_employed.required"> * Self Employed detail is required</p>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-center" v-if="loaderStatus">
                                    <loader></loader>
                                </div>
                                <div class="text-center" v-else>
                                <base-button type="primary" size="lg" @click.prevent="registerMember">Register Member</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Loader from "../../components/Loader"
    const { required, email } = require('vuelidate/lib/validators');
    export default {
        name: "registerMember",
        data() {
            return {
                last_name: '',
                first_name: '',
                user_email: '',
                dependents: '',
                marital_status: '',
                gender: '',
                address: '',
                telephone: '',
                member_shares: '',
                id_no: '',
                education: '',
                self_employed: '',
                property_area: ''

            }
        },
        validations: {
            last_name: {
                required
            },
            first_name: {
                required,
            },
            user_email: {
                email
            },
            dependents: {
                required,
            },
            marital_status: {
                required
            },
            gender: {
                required,
            },
            address: {
                required
            },
            telephone: {
                required,
            },
            member_shares: {
                required
            },
            id_no: {
                required,
            },
            education: {
                required
            },
            property_area: {
                required,
            },
            self_employed: {
                required
            },
        },
        components: {
            Loader
        },
        created(){
        this.authorizedUser(this.authorizeAdminOnly);
    },
        methods: {
            status(validation) {
                return {
                    errorBorder: validation.$error,
                    dirty: validation.$dirty,
                };
            },
            registerMember() {
                if (this.$v.$invalid) {
                    Vue.notify({ title: 'Error', text: 'There is a validation error', type: 'warn' });
                } else {
                    const data = {
                        last_name: this.last_name,
                        first_name: this.first_name,
                        email: this.user_email,
                        dependents: this.dependents,
                        marital_status: this.marital_status,
                        gender: this.gender,
                        address: this.address,
                        telephone: this.telephone,
                        member_shares: this.member_shares,
                        id_no: this.id_no,
                        education: this.education,
                        self_employed: this.self_employed,
                        property_area: this.property_area
                    }
                    console.log( data)
                    this.$store.dispatch('registermember_function', data)
                }

            }
        },
    }
</script>

<style scoped>
    .message{
        color: #f57f6c;
        font-size: 0.75rem;
        margin-left: 24px;
        margin-top: 0.3rem;
    }
</style>
